<template lang="pug">
  v-select(
    ref="selectOption"
    v-bind="$attrs"
    :items="options"
    :value="options"
    :menu-props="{ maxHeight: 'auto' }"
    label="Список вариантов"
    disabled-lookup
    outlined
    multiple
    rounded
  )
    template(v-slot:selection="{ item, index }")
      v-chip(v-if="[0, 1, 2].includes(index)" small)
        span {{ item }}
      span(
        v-if="index === 3"
        class="grey-text text-caption"
      ) (и ещё +{{ options.length - 3 }})

    //- Hide default list
    template(v-slot:item="{ item }")
      v-list-item.d-none

    //- Hide default no-data
    template(v-slot:no-data)
      div.d-none

    //- Custom list module
    //- Search
    template(v-slot:prepend-item)
      v-text-field.px-2.mb-2(
        v-model="search"
        label="Введите название варианта..."
        hide-details
        rounded
        flat
        solo
      )
      v-divider

    template(v-slot:append-item)
      v-list.pb-0
        //- Items
        v-virtual-scroll(
          v-if="filteredOptions.length"
          :items="filteredOptions"
          height="180"
          item-height="46"
        )
          template(v-slot:default="{ index, item }")
            validation-observer(
              ref="obsEdit"
              v-if="editable === item"
              v-slot="{ invalid, handleSubmit }"
            )
              validation-provider(
                :name="`option-${index}`"
                :vid="`option-${index}`"
                :rules="`required|included:${options}`"
                v-slot="{ errors }"
              )
                v-text-field.px-1(
                  v-model="option"
                  :key="`edit-${index}`"
                  hide-details="auto"
                  placeholder="Введите новое название"
                  :error-messages="errors"
                  autofocus
                  rounded
                  flat
                  solo
                  @input="trimmedOption"
                  @keyup.enter="handleSubmit(editOption(index))"
                  @blur="clearEditOption"
                )
                  template(v-slot:append)
                    v-btn.successLighten(
                      :disabled="invalid"
                      icon color="success"
                      @click="handleSubmit(editOption(index))"
                    )
                      v-icon mdi-content-save
                    v-btn.ml-1(icon @click.native.stop="clearEditOption")
                      v-icon mdi-close

            v-list-item(v-else :key="item")
              v-list-item-content
                v-list-item-title {{ item }}
              v-list-item-action-text
                v-btn.grey.lighten-4(icon small @click="editable = item")
                  v-icon(small) mdi-pencil
                v-btn.ml-2.error.lighten-4(
                  icon small color="error"
                  @click="deleteOption(item)"
                )
                  v-icon(small) mdi-delete

        //- No data
        div(v-else)
          v-list-item.pb-2
            v-list-item-content
              v-list-item-title: i Варианты не найдены

        //- Actions
        v-divider
        template(v-if="creatable")
          v-list-item
            v-list-item-content
              validation-observer(ref="obs" v-slot="{ invalid, handleSubmit }")
                validation-provider(
                  name="option"
                  vid="option"
                  :rules="`required|included:${options}`"
                  v-slot="{ errors }"
                )
                  v-text-field(
                    v-model="option"
                    rounded
                    flat
                    solo
                    autofocus
                    hide-details="auto"
                    background-color="transparent"
                    placeholder="Введите название варианта"
                    :error-messages="errors"
                    @input="trimmedOption"
                    @keyup.enter="handleSubmit(addOption)"
                    @blur="clearCreateOption"
                  )
                    template(v-slot:append)
                      v-btn.successLighten(
                        :disabled="invalid"
                        icon color="success"
                        @click="handleSubmit(addOption)"
                      )
                        v-icon mdi-plus
                      v-btn.ml-1(icon @click.native.stop="clearCreateOption")
                        v-icon mdi-close
        template(v-else)
          v-list-item(@click="creatable = true")
            v-list-item-avatar.success
              v-icon(dark) mdi-plus
            v-list-item-content
              v-list-item-title Добавить вариант

        v-card-actions.pb-0
          v-btn(@click="hideSelectOptionMenu" block)
            v-icon(left) mdi-keyboard-backspace
            span Скрыть меню
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      search: '',
      option: '',
      options: [],

      editable: null,
      creatable: false,
      trimmerRegexp: /\s(?=\s)/g,
    };
  },
  computed: {
    filteredOptions() {
      const { search } = this;
      return this.options.filter((i) => i.includes(search));
    },
  },
  watch: {
    value: {
      handler(val) {
        this.options = val;
      },
      immediate: true,
    },
    options(val) {
      this.$emit('input', val);
    },
    editable(val) {
      this.option = val || '';
    },
  },
  methods: {
    deleteOption(item) {
      const index = this.options.findIndex((el) => item === el);
      this.options.splice(index, 1);
      this.clearEditOption();
    },
    editOption(index) {
      this.options.splice(index, 1, this.option);
      this.clearEditOption();
    },
    addOption() {
      const { option } = this;
      this.options.unshift(option);
      this.clearCreateOption();
    },
    trimmedOption(value) {
      const { trimmerRegexp } = this;
      this.option = value.replace(trimmerRegexp, '').trim();
    },
    clearEditOption() {
      const { obsEdit } = this.$refs;
      if (obsEdit?.reset) obsEdit.reset();
      this.option = '';
      this.editable = null;
    },
    clearCreateOption() {
      const { obs } = this.$refs;
      if (obs?.reset) obs.reset();
      this.option = '';
      this.creatable = false;
    },
    hideSelectOptionMenu() {
      const { selectOption } = this.$refs;
      if (selectOption?.blur) selectOption.blur();
    },
  },
};
</script>
